// extracted by mini-css-extract-plugin
export var category = "_ke-9";
export var categoryHeader = "_ke-e";
export var container = "_ke-0";
export var group = "_ke-a";
export var groupItems = "_ke-f";
export var groupSeparator = "_ke-j";
export var loading = "_ke-1";
export var noResults = "_ke-3";
export var placeholder = "_ke-2";
export var resultContent = "_ke-5";
export var resultIcon = "_ke-c";
export var resultItem = "_ke-g";
export var resultMeta = "_ke-8";
export var resultSubtitle = "_ke-7";
export var resultSuffix = "_ke-i";
export var resultTitle = "_ke-6";
export var resultsList = "_ke-4";
export var searchGroup = "_ke-d";
export var selected = "_ke-h";
export var subgroup = "_ke-b";